import React,{useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom';
import {URL} from '../Helper/helper'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './PermBookingComponent.css';

function PermBookingComponent({
    togglePermBookingView,
    totalPrice,
    formatDate,
    timingsArr,
    courtSelected,
    date_Selected,
    addBookings,
    weekday}) {
  //new Date().toLocaleDateString("fr-CA")
  const navigate = useNavigate();

  let startTime = timingsArr.length > 1 ? timingsArr[0].split('-')[0] : timingsArr[0] && timingsArr[0].split('-')[0]
    //timingsArr[0].split('-')[0]
  let endTime = timingsArr.length > 1 ? timingsArr[timingsArr.length -1].split('-')[1] : timingsArr[0] && timingsArr[0].split('-')[1]

  const[startDate,setStartDate] = useState(new Date(date_Selected));
  const[endDate,setEndDate] = useState(new Date());
  const[sTime,setSTime] = useState(startTime)
  const[eTime,setETime] = useState(endTime)
  const[bookingStatus,setBookingStatus] = useState('')
  const[payStatus,setPayStatus] = useState('')
  const[bookingType,setBookingType] = useState('')
  const[playersCount,setPlayersCount] = useState(0)
  const[day,setDay] = useState(-1)
  const[userName,setUserName] = useState('')
  const[email,setEmail] = useState('')
  const[contact,setContact] = useState('')
  const[price,setPrice] = useState(0)
  const[discountValue,setDiscountValue] = useState(0)
  const[netPrice,setNetPrice] = useState(0)
  const[grandTotal,setGrandTotal] = useState(totalPrice)
  const[addPBookings,setAddPBookings] = useState([...addBookings])
  const[dateSelected,setDateSelected] = useState(new Date().toLocaleDateString("fr-CA"))
  const[invalidUserName,setInvalidUserName] = useState(false)

  // Username validation functions
  const isEmail = (str) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(str);
  };

  const isWebsiteURL = (str) => {
    const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;
    return urlRegex.test(str);
  };

  const validateUsername = (username) => {
    if (isEmail(username) || isWebsiteURL(username)) {
      setInvalidUserName(true);
      return false;
    } else {
      setInvalidUserName(false);
      return true;
    }
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUserName(value);
    if (value.trim()) {
      validateUsername(value);
    } else {
      setInvalidUserName(false);
    }
  };





  const handleAddBooking = async() => {
    // Validate username before proceeding
    if (!validateUsername(userName)) {
      alert('Please enter a valid username. Usernames cannot be email addresses or website URLs.');
      return;
    }

    let count = 0;
    console.log('Add_Bookings',addPBookings)

    const new_perm_bookings_arr = addPBookings.map((b_item,index) =>{

        const{booking_time_start,booking_time_end,booking_item} = b_item;
        let bookingObj = {
            booking_date_start:startDate.toLocaleDateString("fr-CA"),
            booking_date_end:endDate.toLocaleDateString("fr-CA"),
            booking_time_start:booking_time_start,
            booking_time_end:booking_time_end,
            booking_item:booking_item,
            userName:userName,
            email,
            contact,
            discount:discountValue,
            grandTotal:grandTotal.toFixed(2),
            netPrice:netPrice === 0 ? grandTotal : netPrice.toFixed(2),
            booking_status:bookingStatus,
            booking_type:bookingType,
            pay_status:payStatus,
            players_count:playersCount,
            booking_price:totalPrice,
            day_of_week:day !== -1 ? weekday[day] : weekday[((new Date(date_Selected)).getDay())],
            court_no:booking_item
        }

        return bookingObj;
    })

    console.log('P_Booking_New',new_perm_bookings_arr)

    for(let i=0; i < new_perm_bookings_arr.length; i++){
        const options = {
            method: "POST",
            headers: {
              "content-type": "application/json"
            },
            body: JSON.stringify(new_perm_bookings_arr[i])
          }
          const response = await fetch(`${URL}`+'/perbookings',options)
          const status = response.json();

          if(response.ok){
                count = i+1;
          }
    }

    if(count === new_perm_bookings_arr.length){
                setStartDate(new Date())
                setEndDate(new Date())
                setSTime('')
                setETime('')
                setUserName('')
                setBookingStatus('')
                setBookingType('')
                setPayStatus('')
                setDay(-1)
                setPlayersCount(0)
                alert('Per Booking Record Created Successfully !!!')
                navigate('/user')
    }
  }


const calcDiscount = (e) =>{
    e.preventDefault()
    let discountAmount = Math.abs(discountValue / 100 );
    let d_price = totalPrice * discountAmount ;
    let priceAfterDiscount = totalPrice - d_price;
    setNetPrice(prev => prev + priceAfterDiscount)
    setPrice(priceAfterDiscount)
}

  return (
    <div className='perm-booking-page'>
      <div className="container admin-container">
        {/* Permanent Booking Header */}
        <div className="perm-booking-header">
          <a
            className="back-link"
            href="#"
            onClick={() => togglePermBookingView()}>
            <i className="fa fa-arrow-left me-2"></i>
            Back to Home
          </a>
          <h2>
            <i className="fa fa-calendar-plus text-primary"></i>
            Permanent Bookings
          </h2>
          <p>Create recurring bookings for regular court reservations</p>
        </div>

        {/* Permanent Booking Form */}
        <div className="perm-booking-form-container">
          <form className="perm-booking-form">
            {/* Date Selection Section */}
            <div className="row">
              <div className="col-12">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-calendar"></i>
                    Date Range
                  </h5>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="start_date" className="form-label">
                          <i className="fa fa-calendar-plus"></i>
                          Start Date
                        </label>
                        <input
                          type="text"
                          className='form-control'
                          name="start_date"
                          id="start_date"
                          value={startDate.toLocaleDateString("fr-CA")}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="info-display">
                        <h6>
                          <i className="fa fa-calendar-day me-2"></i>
                          Day of Week
                        </h6>
                        <div className="info-value">
                          {day !== -1 ? weekday[day] : weekday[((new Date(date_Selected)).getDay())]}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="end_date" className="form-label">
                          <i className="fa fa-calendar-minus"></i>
                          End Date
                        </label>
                        <DatePicker
                          className="form-control"
                          dateFormat="yyyy-MM-dd"
                          selected={endDate}
                          minDate={new Date()}
                          onChange={(date) => {
                            let day_of_week = date?.getDay()
                            let f_date = formatDate(date)
                            setEndDate(date)
                            setDateSelected(f_date)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Time and Court Information */}
            <div className="row">
              <div className="col-12">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-clock"></i>
                    Booking Details
                  </h5>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="info-display">
                        <h6>
                          <i className="fa fa-play me-2 text-success"></i>
                          Start Time
                        </h6>
                        <div className="info-value text-success">{sTime}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="info-display">
                        <h6>
                          <i className="fa fa-stop me-2 text-danger"></i>
                          End Time
                        </h6>
                        <div className="info-value text-danger">{eTime}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="info-display">
                        <h6>
                          <i className="fa fa-map-marker me-2 text-primary"></i>
                          Court Number
                        </h6>
                        <div className="info-value">Court-{courtSelected}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Booking Configuration */}
            <div className="row">
              <div className="col-12">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-cog"></i>
                    Booking Configuration
                  </h5>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="book-status" className="form-label">
                          <i className="fa fa-check-circle"></i>
                          Booking Status
                        </label>
                        <select
                          name="book-status"
                          id="book-status"
                          value={bookingStatus}
                          onChange={e => setBookingStatus(e.target.value)}
                          required
                          className="form-control">
                          <option value="-1">-- Select Status --</option>
                          <option value="Reserved">Reserved</option>
                          <option value="UnRes">Unreserved</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="pay-status" className="form-label">
                          <i className="fa fa-credit-card"></i>
                          Payment Status
                        </label>
                        <select
                          name="pay-status"
                          id="pay-status"
                          value={payStatus}
                          onChange={e => setPayStatus(e.target.value)}
                          required
                          className="form-control">
                          <option value="-1">-- Select Payment --</option>
                          <option value="EFTPOS">EFTPOS</option>
                          <option value="Cash">Cash</option>
                          <option value="Complimentary">Complimentary</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="discount" className="form-label">
                          <i className="fa fa-percent"></i>
                          Discount Percentage
                        </label>
                        <div className="discount-container">
                          <div className="discount-input">
                            <input
                              type="number"
                              className='form-control'
                              value={discountValue}
                              onChange={e => setDiscountValue(e.target.value)}
                              placeholder="Enter discount %"
                              min="0"
                              max="100"
                            />
                          </div>
                          <button
                            type="button"
                            className='discount-btn'
                            onClick={calcDiscount}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Price Display */}
            <div className="price-display">
              <h4>
                <i className="fa fa-dollar me-2"></i>
                Total Price
              </h4>
              <p className='price-amount'>
                A${price > 0 ? price.toFixed(2) : totalPrice.toFixed(2)}
              </p>
            </div>

            {/* Additional Details */}
            <div className="row">
              <div className="col-12">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-user"></i>
                    Additional Details
                  </h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="book-type" className="form-label">
                          <i className="fa fa-bookmark"></i>
                          Booking Type
                        </label>
                        <select
                          name="book-type"
                          id="book-type"
                          value={bookingType}
                          onChange={e => setBookingType(e.target.value)}
                          required
                          className="form-control">
                          <option value="-1">-- Select Type --</option>
                          <option value="Per">Permanent</option>
                          <option value="Prepaid">Prepaid</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="player_count" className="form-label">
                          <i className="fa fa-users"></i>
                          Number of Players
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={playersCount}
                          onChange={e => setPlayersCount(e.target.value)}
                          id="player_count"
                          name="player_count"
                          min="1"
                          max="50"
                          required
                          placeholder="Enter number of players"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* User Information */}
            <div className="row">
              <div className="col-12">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-address-card"></i>
                    User Information
                  </h5>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="user_name" className="form-label">
                          <i className="fa fa-user"></i>
                          Username
                        </label>
                        <input
                          type="text"
                          className='form-control'
                          name="user_name"
                          id="user_name"
                          value={userName}
                          onChange={handleUsernameChange}
                          required
                          placeholder="Enter username"
                        />
                        {invalidUserName && (
                          <div className="error-message">
                            <i className="fa fa-exclamation-circle me-1"></i>
                            Usernames cannot be email addresses or website URLs
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label">
                          <i className="fa fa-envelope"></i>
                          Email Address
                        </label>
                        <input
                          type="email"
                          className='form-control'
                          name="email"
                          id="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          required
                          placeholder="Enter email address"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="contact" className="form-label">
                          <i className="fa fa-phone"></i>
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className='form-control'
                          name="contact"
                          id="contact"
                          value={contact}
                          onChange={e => setContact(e.target.value)}
                          required
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Submit Section */}
            <div className="submit-section">
              <button
                type="button"
                onClick={() => handleAddBooking()}
                className="submit-btn"
                disabled={invalidUserName}
              >
                <i className="fa fa-calendar-plus me-2"></i>
                Create Permanent Booking
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PermBookingComponent

//(countDays(startDate,endDate,day) * totalPrice)
// discountValue > 0 ? discountPrice.toFixed(2) : price.toFixed(2)